import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Channels extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)',
          color: 'blue',
          basic: true,
          handler: this._handleBack 
        },
        { 
          label: 't(Next)',
          color: 'blue',
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Address)',
              instructions: 't(Provide the physical location of your business)',
              name: 'identity_business_address',
              type: 'addressfield',
              required: true,
              defaultValue: config.identity_business_address 
            },
            { 
              label: 't(Email)',
              instructions: 't(Enter the primary email address used for business communications)',
              name: 'identity_business_email',
              type: 'emailfield',
              required: true,
              defaultValue: config.identity_business_email
            },
            { 
              label: 't(Phone)',
              instructions: 't(Provide the main contact number for client inquiries and business communication)',
              name: 'identity_business_phone',
              type: 'phonefield',
              required: true,
              defaultValue: config.identity_business_phone 
            }
          ] 
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata } = this.props
    this.props.onNext({
      ...formdata,
      ...config
    })
  }

}

export default Channels
